import { RulesTable } from "../widgets/RulesTable";

/** summarize the syntax for sound changing rules */
export function RuleSummary() {
  return (<RulesTable rules={[
    { rule: "a > b", other: <>change a into b</> },
    { rule: "a > ∅", other: <>remove a</> },
    { rule: "", other: <>&nbsp;</> },

    { rule: "a > b / c_d", other: <>...when preceded by c and followed by d</> },
    { rule: "a > b / #_", other: <>...at the start of a word</> },
    { rule: "a > b / _#", other: <>...at the end of a word</> },
    { rule: "", other: <>&nbsp;</> },

    { rule: "a > b / V_C", other: <>...when preceded by a vowel and followed by a consonant</> },
    { rule: "a > b / t_", other: <>...when preceded by a t</> },
    { rule: "a > b / [+voiced] [+trill]_[+dental]", other: <>...when preceded by a voiced trill and followed by a dental</> },
    { rule: "", other: <>&nbsp;</> },

    { rule: "a > b / {V|ɹ|[+long]}_V", other: <>OR: when any of a set of options is met</> },
    { rule: "a > b / {V&[+long]}_V", other: <>AND: when all of a set of options is met</> },
    { rule: "a > b / _!V", other: <>NOT: when a pattern is not matched</> },
    { rule: "a > b / !{V|ɹ}_", other: <>...not a vowel or ɹ</> },
    { rule: "", other: <>&nbsp;</> },

    { rule: "a > b / 'U'", other: <>...in an unstressed syllable</> },
    { rule: "a > b / 'S_A_'", other: <>...when preceded by stressed syllable, but current syllable is any type</> },
    { rule: "", other: <>&nbsp;</> },

    { rule: "a > b *(next)", other: <>...then swap with the next symbol</> },
    { rule: "a > b *(prev)", other: <>...then swap with the previous symbol</> },
    { rule: "", other: <>&nbsp;</> },

    { rule: "reset", other: <>reset tracking of symbol changes</> },
    { rule: "// comment", other: <>useful for explaing rules, otherwise ignored</> },
  ]} />)
}
